export const termsOfUseState = {
    errorCode : 0,
    statusCode : 0,
    termsConditionSetting : [],
    updatedValue : ''
}
